import { defineComponent, computed, createBlock, openBlock, normalizeStyle } from "vue";
import { _ as _sfc_main$1 } from "./p-icon.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PRingLoader"
  },
  __name: "p-ring-loader",
  props: {
    size: { default: 80 },
    color: { default: "" }
  },
  setup(__props) {
    const props = __props;
    const spinnerSize = computed(() => props.size * 0.892);
    const style = computed(() => ({
      color: props.color
    }));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        icon: "svg-spinners:90-ring-with-bg",
        width: spinnerSize.value,
        class: "text-p-blue-60",
        style: normalizeStyle(style.value)
      }, null, 8, ["width", "style"]);
    };
  }
});
export {
  _sfc_main as _
};
